import { render, staticRenderFns } from "./paypalCheckout.vue?vue&type=template&id=1cb9da20&scoped=true&"
import script from "./paypalCheckout.vue?vue&type=script&lang=ts&"
export * from "./paypalCheckout.vue?vue&type=script&lang=ts&"
import style0 from "./paypalCheckout.vue?vue&type=style&index=0&id=1cb9da20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb9da20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
